(ns app.front.ui.util
  (:require [core.db.entity-api :as entity-api]
            [reagent.core :as r]))

(defn- unwrap-children [children]
  (mapcat #(if (seq? %) % [%]) children))

(defn xtract-args
  "Returns tuple with opts (or empty map) and children"
  [args]
  (let [props     (first args)
        has-props (map? props)
        children  (if has-props (rest args) args)]
    [(if has-props props {})
     (unwrap-children children)]))

(defn wrap-in
  "Make a component for wrapping children in an element

  e.g.
  (def cool (wrap-in :marquee))

  [cool [:div]] => [:marquee [:div]]
  [cool {:style ...} [:div]] => [:marquee {:style ...} [:div]]

  (def cool (wrap-in :article {} :marquee {}))

  [cool [:div] [:div]] => [:article [:marquee [:div]] [:marquee [:div]]]"
  ([wrap-in-el] (wrap-in wrap-in-el nil nil nil))
  ([wrap-in-el props-or-child-wrapper]
   (if (map? props-or-child-wrapper)
     (wrap-in wrap-in-el props-or-child-wrapper nil nil)
     (wrap-in wrap-in-el {} props-or-child-wrapper {})))
  ([wrap-in-el default-props wrap-children-in-el child-props]
   (fn [& args]
     (let [[props children] (xtract-args args)]
       (->> children
            (map (fn [c]
                   (if wrap-children-in-el
                     [wrap-children-in-el child-props c]
                     c)))
            (into [wrap-in-el (r/merge-props default-props
                                             props)]))))))

(defn string-id
  "Make a string id from things that can be easily represented as string.
   Returns `nil` for collections, except if it's a map (or entity) with :db/id or :id keys, returns the id."
  [v]
  (cond
    (string? v) v
    (or (keyword? v) (number? v)) (str v)
    ;; for entities, use :db/id only as it should be unique
    (or (entity-api/entity? v)
        (and (map? v) (:db/id v))) (-> v :db/id str)
    (and (map? v) (:id v)) (-> v :id str)))

(defn make-token->value
  "Make a map from an arbitrary string (token) to any value, for use with
  HTML input elements where only string values are allowed. A custom tokenizer val->token can be given if
  default tokenizer is not applicable."
  [allow-empty? val->token values]
  (->> values
       (map-indexed (fn [ix q] [(or (string-id q) ;; for entities, compare by id only, as id should be unique
                                    (when val->token (-> q val->token str))
                                    (str ix))
                                {:ix ix :value q}]))
       (into (if allow-empty? {"nil" nil} {}))))


(defn get-token
  "For a map created with `make-token->value`, get the token (string)
  that corresponds to a value."
  [token->value value]
  (let [unique-token (cond
                       (entity-api/entity? value) (str (:db/id value))
                       (keyword? value) (str value))]
    (if (and unique-token
             (contains? token->value unique-token))
      unique-token
      (->> token->value
           (filter (comp (partial = value) :value second))
           ffirst))))


(def sort-tokens (partial sort-by (comp :ix second)))
